import Entity from '../entity'
import ProductComment from './ProductComment';
import ProductImage from './ProductImage';
import ProductAppointmentOption from './ProductAppointmentOption';

export default class Product extends Entity<number> {
    name: string = null;
    details: string = null;
    specArgs: string = null;
    productCategoryId: number = null;
    productCategoryNo: string;
    brandId: number = null;
    unitPrice: string = null;
    discountUnitPrice: string = null;
    coverImageUrl: string = null;
    priority: number = null;
    tenantId: number = null;
    description: string = null;
    unit: string = null;
    adImageUrl: string = null;
    adPriority: number = null;
    adTargetUrl: string = null;
    isAdvertised: boolean;
    isPublished: boolean;
    isRecommended: boolean;
    recommendedPriority: number = null;
    isHotRecommended: boolean;
    hotRecommendedPriority: number = null;
    isNew: boolean;
    newPriority: number = null;
    isCompetitive: boolean;
    competitivePriority: number = null;
    coverImageHash: string = null;
    productColorId: number = null;
    productNo: string = null;
    linkUrl: string = 'http://fdm.ink/';
    linkUrlKey: string = '888888';
    status: number = null;
    remark: string = null;
    productComments: Array<ProductComment>;
    productImages: Array<ProductImage>;
    productAppointmentOptions: Array<ProductAppointmentOption>;
    vendorNo: string;
    keywords: string = null;
    saleCount: number;
    creationTime: string;
    auditKey: string;
    appointmentEnabled: boolean = false;
}